"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Href = void 0;
const utils_1 = require("@obvio/utils");
const Href = class Href extends URL {
    constructor(path, search, hash) {
        super(path, 'http://o');
        this.search =
            new URLSearchParams(Object.fromEntries([...new URLSearchParams(search).entries()].filter(([, val]) => !['null', 'undefined'].includes(val)))).toString() || this.search;
        this.hash = hash !== null && hash !== void 0 ? hash : this.hash;
    }
    get query() {
        return `${this.search.replace(/[=](&|$)/gu, '$1').replaceAll('%2C', ',')}${this.hash}`;
    }
    toString() {
        return `${this.pathname.replace(/([^/])\/+$/u, '$1')}${this.query}`;
    }
    addParams(params) {
        (0, utils_1.map)((val, key) => {
            if (val) {
                this.searchParams.append(key, val);
            }
        }, params);
    }
    removeParams(...params) {
        params.forEach((param) => this.searchParams.delete(param));
    }
};
exports.Href = Href;
